var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPinMsgInboxAlone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "19px",
    viewBox: "0 0 11 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPinMsgInboxAlone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-pined",
    transform: "translate(-32.000000, -236.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(18.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(2.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPinMsgInbox",
    transform: "translate(17.646447, 17.853553) rotate(-45.000000) translate(-17.646447, -17.853553) translate(9.146447, 9.353553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27716344,13.4197262 L1.35311062,16.3364689 L0.646889382,15.6284776 L3.56917001,12.7135027 L0.407362519,9.55959974 L0.759954935,9.20560497 C2.16272429,7.79725644 4.23913859,7.3633037 6.07001846,8.02645287 L10.0190982,4.08724586 C9.8030457,2.88461105 10.1776389,1.63170587 11.0632817,0.748277123 L11.4163923,0.396049272 L16.7572677,5.72357247 L16.4023849,6.07756808 C15.5088321,6.96888691 14.2516039,7.33676049 13.0366908,7.11094379 L9.09915881,11.038632 C9.77072951,12.8647571 9.33731525,14.9452193 7.92500816,16.3539956 L7.57189754,16.7062235 L4.27716344,13.4197262 Z M5.98825288,9.07047805 C4.61098525,8.46310301 3.01633997,8.6615337 1.84292509,9.57912651 L7.55025485,15.272188 C8.47251337,14.0934944 8.66987914,12.4955941 8.0546573,11.1238303 L7.91343454,10.8089451 L12.7284357,6.00598138 L13.0062974,6.0797436 C13.8042725,6.291577 14.6421383,6.14942494 15.3089498,5.69132224 L11.4486522,1.84067541 C10.9922086,2.50185201 10.8449284,3.33619778 11.0498123,4.12175148 L11.1222109,4.39933783 L6.30106684,9.20842901 L5.98825288,9.07047805 Z",
    id: "icPinMsgInboxAlone"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinMsgInboxAlone);
export default __webpack_public_path__ + "static/media/icPinMsgInboxAlone.2c93fd6fffaf9f4d05efb1bd6a59a1d6.svg";
export { ForwardRef as ReactComponent };